import React, { useState } from "react";
import { Plus, Eye, Edit2, Trash2, ChevronDown } from "lucide-react";
import axios from "../routers/axios";
import dayjs from "dayjs";
import TestDetailModal from "./Modals/TestDetailModal";

const TestList = ({ tests = [], onCreate, onOpenScenarioModal, onSelectScenario }) => {
  const [scenariosByTest, setScenariosByTest] = useState({});
  const [loadingTestId, setLoadingTestId] = useState(null);
  const [expandedTestId, setExpandedTestId] = useState(null);
  const [selectedTest, setSelectedTest] = useState(null);
  const [modalMode, setModalMode] = useState(null);

  const fetchScenarios = async (testId) => {
    try {
      setLoadingTestId(testId);
      const res = await axios.get(`/scenarios/list?test_id=${testId}`);
      setScenariosByTest((prev) => ({
        ...prev,
        [testId]: Array.isArray(res.data) ? res.data : [],
      }));
    } catch (error) {
      console.error("Lỗi khi lấy scenarios:", error);
      setScenariosByTest((prev) => ({ ...prev, [testId]: [] }));
    } finally {
      setLoadingTestId(null);
    }
  };

  const toggleExpand = (testId) => {
    if (expandedTestId === testId) {
      setExpandedTestId(null);
    } else {
      fetchScenarios(testId);
      setExpandedTestId(testId);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "28px" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px", flexWrap: "wrap" }}>
        <h2 style={{
          fontSize: "22px",
          fontWeight: 600,
          color: "#111827",
          letterSpacing: "-0.3px",
          margin: 0,
        }}>
          Quản lý bài Test
        </h2>
        <button
          onClick={onCreate}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px 20px",
            background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
            color: "#fff",
            fontSize: "14px",
            fontWeight: 600,
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(37,99,235,0.35), 0 1px 2px rgba(37,99,235,0.2)",
            transition: "all 0.18s ease",
            letterSpacing: "0.01em",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = "0 4px 14px rgba(37,99,235,0.45), 0 2px 4px rgba(37,99,235,0.25)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(37,99,235,0.35), 0 1px 2px rgba(37,99,235,0.2)";
          }}
        >
          <Plus size={16} strokeWidth={2.5} />
          Tạo mới
        </button>
      </div>

      {/* Table card */}
      <div style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        overflow: "hidden",
        boxShadow: "0 1px 4px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04)",
      }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
            <thead>
              <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e5e7eb" }}>
                {["Tên bài test", "Trạng thái", "Scenarios", "Ngày tạo", "Hành động"].map((header) => (
                  <th
                    key={header}
                    style={{
                      padding: "13px 20px",
                      textAlign: "left",
                      fontSize: "11px",
                      fontWeight: 700,
                      color: "#6b7280",
                      textTransform: "uppercase",
                      letterSpacing: "0.07em",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {tests.length > 0 ? (
                tests.map((test) => {
                  const scenarios = scenariosByTest[test.id] || [];
                  const count = scenarios.length || test.scenarios?.length || 0;
                  const isExpanded = expandedTestId === test.id;

                  return (
                    <React.Fragment key={test.id}>
                      {/* Main row */}
                      <tr
                        style={{
                          borderBottom: "1px solid #f1f5f9",
                          cursor: "pointer",
                          transition: "background 0.12s ease",
                          background: isExpanded ? "#f8fafc" : "transparent",
                        }}
                        onMouseEnter={e => { if (!isExpanded) e.currentTarget.style.background = "#fafbfc"; }}
                        onMouseLeave={e => { if (!isExpanded) e.currentTarget.style.background = isExpanded ? "#f8fafc" : "transparent"; }}
                        onClick={() => toggleExpand(test.id)}
                      >
                        {/* Name + chevron */}
                        <td style={{ padding: "16px 20px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <span style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "22px",
                              height: "22px",
                              borderRadius: "6px",
                              background: isExpanded ? "#eff6ff" : "#f3f4f6",
                              transition: "all 0.15s ease",
                              flexShrink: 0,
                            }}>
                              <ChevronDown
                                size={13}
                                color={isExpanded ? "#3b82f6" : "#9ca3af"}
                                style={{
                                  transition: "transform 0.2s ease",
                                  transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                                }}
                              />
                            </span>
                            <span style={{ fontWeight: 500, color: "#111827", fontSize: "14px" }}>
                              {test.test_name}
                            </span>
                          </div>
                        </td>

                        {/* Status */}
                        <td style={{ padding: "16px 20px", whiteSpace: "nowrap" }}>
                          <span style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "5px 12px",
                            borderRadius: "20px",
                            fontSize: "13px",
                            fontWeight: 500,
                            background: test.is_active ? "#f0fdf4" : "#fef2f2",
                            color: test.is_active ? "#15803d" : "#dc2626",
                            border: `1px solid ${test.is_active ? "#bbf7d0" : "#fecaca"}`,
                          }}>
                            <span style={{
                              width: "6px",
                              height: "6px",
                              borderRadius: "50%",
                              background: test.is_active ? "#22c55e" : "#f87171",
                              boxShadow: test.is_active
                                ? "0 0 0 2px rgba(34,197,94,0.2)"
                                : "0 0 0 2px rgba(248,113,113,0.2)",
                            }} />
                            {test.is_active ? "Hoạt động" : "Tạm dừng"}
                          </span>
                        </td>

                        {/* Scenario count */}
                        <td style={{ padding: "16px 20px", whiteSpace: "nowrap" }}>
                          {loadingTestId === test.id ? (
                            <span style={{ color: "#9ca3af", fontSize: "13px", fontStyle: "italic" }}>Đang tải...</span>
                          ) : (
                            <span style={{
                              display: "inline-flex",
                              alignItems: "center",
                              padding: "5px 12px",
                              borderRadius: "20px",
                              fontSize: "13px",
                              fontWeight: 500,
                              background: count > 0 ? "#eff6ff" : "#f9fafb",
                              color: count > 0 ? "#2563eb" : "#6b7280",
                              border: `1px solid ${count > 0 ? "#bfdbfe" : "#e5e7eb"}`,
                            }}>
                              {count} scenario{count !== 1 ? "s" : ""}
                            </span>
                          )}
                        </td>

                        {/* Date */}
                        <td style={{ padding: "16px 20px", whiteSpace: "nowrap", color: "#6b7280", fontSize: "13px" }}>
                          {test.created_at
                            ? dayjs(test.created_at).format("DD/MM/YYYY HH:mm")
                            : "—"}
                        </td>

                        {/* Actions */}
                        <td style={{ padding: "16px 20px", whiteSpace: "nowrap" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                            {[
                              { icon: Eye, color: "#3b82f6", bg: "#eff6ff", border: "#bfdbfe", title: "Xem chi tiết", mode: "view" },
                              { icon: Edit2, color: "#059669", bg: "#ecfdf5", border: "#a7f3d0", title: "Chỉnh sửa", mode: "edit" },
                              { icon: Trash2, color: "#dc2626", bg: "#fef2f2", border: "#fecaca", title: "Xóa", mode: "delete" },
                            ].map(({ icon: Icon, color, bg, border, title, mode }) => (
                              <button
                                key={mode}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedTest(test);
                                  setModalMode(mode);
                                }}
                                title={title}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "8px",
                                  border: "1px solid transparent",
                                  background: "transparent",
                                  color: "#9ca3af",
                                  cursor: "pointer",
                                  transition: "all 0.15s ease",
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.background = bg;
                                  e.currentTarget.style.borderColor = border;
                                  e.currentTarget.style.color = color;
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.background = "transparent";
                                  e.currentTarget.style.borderColor = "transparent";
                                  e.currentTarget.style.color = "#9ca3af";
                                }}
                              >
                                <Icon size={15} strokeWidth={1.8} />
                              </button>
                            ))}
                          </div>
                        </td>
                      </tr>

                      {/* Expanded scenarios row */}
                      {isExpanded && (
                        <tr>
                          <td colSpan="5" style={{
                            background: "linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)",
                            borderBottom: "1px solid #e5e7eb",
                            padding: "20px 24px",
                          }}>
                            {loadingTestId === test.id ? (
                              <p style={{ color: "#3b82f6", fontSize: "14px", margin: 0 }}>
                                Đang tải danh sách scenarios...
                              </p>
                            ) : (
                              <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                                <p style={{
                                  fontSize: "11px",
                                  fontWeight: 700,
                                  color: "#9ca3af",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.08em",
                                  margin: 0,
                                }}>
                                  Danh sách Scenarios
                                </p>

                                <div style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                                  gap: "12px",
                                }}>
                                  {scenarios.length > 0 ? (
                                    scenarios.map((sc, index) => (
                                      <div
                                        key={sc.id}
                                        onClick={() => onSelectScenario(sc)}
                                        style={{
                                          background: "#fff",
                                          border: "1px solid #e5e7eb",
                                          borderRadius: "10px",
                                          padding: "14px 16px",
                                          cursor: "pointer",
                                          transition: "all 0.15s ease",
                                          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                                        }}
                                        onMouseEnter={e => {
                                          e.currentTarget.style.borderColor = "#93c5fd";
                                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(59,130,246,0.1)";
                                          e.currentTarget.style.transform = "translateY(-1px)";
                                        }}
                                        onMouseLeave={e => {
                                          e.currentTarget.style.borderColor = "#e5e7eb";
                                          e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.04)";
                                          e.currentTarget.style.transform = "translateY(0)";
                                        }}
                                      >
                                        <p style={{
                                          fontSize: "10px",
                                          fontWeight: 700,
                                          color: "#9ca3af",
                                          textTransform: "uppercase",
                                          letterSpacing: "0.07em",
                                          margin: "0 0 6px 0",
                                        }}>
                                          Scenario {index + 1}
                                        </p>
                                        <h5
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            color: "#111827",
                                            margin: "0 0 10px 0",
                                            lineHeight: "1.4",
                                            display: "-webkit-box",
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                          }}
                                          dangerouslySetInnerHTML={{ __html: sc.scenario_name }}
                                        />
                                        <p style={{ fontSize: "13px", color: "#6b7280", margin: 0 }}>
                                          <span style={{ color: "#2563eb", fontWeight: 600 }}>{sc.level}</span>
                                          <span style={{ margin: "0 5px", color: "#d1d5db" }}>·</span>
                                          {sc.duration_minutes} phút
                                        </p>
                                      </div>
                                    ))
                                  ) : (
                                    <p style={{ fontSize: "14px", color: "#9ca3af", gridColumn: "1/-1", margin: 0 }}>
                                      Chưa có scenario nào cho bài test này.
                                    </p>
                                  )}

                                  {/* Add scenario card */}
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onOpenScenarioModal(test, () => fetchScenarios(test.id));
                                    }}
                                    style={{
                                      border: "1.5px dashed #d1d5db",
                                      borderRadius: "10px",
                                      minHeight: "88px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      background: "transparent",
                                      cursor: "pointer",
                                      transition: "all 0.15s ease",
                                    }}
                                    onMouseEnter={e => {
                                      e.currentTarget.style.borderColor = "#93c5fd";
                                      e.currentTarget.style.background = "#eff6ff";
                                    }}
                                    onMouseLeave={e => {
                                      e.currentTarget.style.borderColor = "#d1d5db";
                                      e.currentTarget.style.background = "transparent";
                                    }}
                                  >
                                    <Plus size={18} color="#9ca3af" />
                                  </button>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" style={{ padding: "64px 24px", textAlign: "center", color: "#9ca3af", fontSize: "14px" }}>
                    Chưa có bài test nào
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {selectedTest && (
        <TestDetailModal
          mode={modalMode}
          test={selectedTest}
          onClose={() => {
            setSelectedTest(null);
            setModalMode(null);
          }}
          onUpdated={() => window.location.reload()}
        />
      )}
    </div>
  );
};

export default TestList;